'use client';

import SignInLayout from '../../layouts/desktop/signin';

// El signin es viewport-agnóstico: el mismo card se muestra en desktop y en
// móvil (el layout maneja el responsive vía max-width fluido). El wrapper
// `<LayoutDesktop>` / `<LayoutMobile>` que agrega `_app.tsx` no renderiza
// header/footer cuando no hay sesión, así que no interfiere con la vista.
export default function SignIn() {
  return <SignInLayout />;
}
